module.exports = __webpack_public_path__ + "static/b748cd77ade36ecbb1da84cf094d0cb8a15c30325d72eaa0d0fffbe7740193c8-e85c5a6643c8031d0baf07a1774b2b70.png";